// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.tours.RentalManagerUserPropertyToursWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyToursWebApiHandler_getCountForListings,
  RentalManagerUserPropertyToursWebApiHandler_getCountForListings_Path,
  RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders,
  RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Path,
  RentalManagerUserPropertyToursWebApiHandler_tours,
  RentalManagerUserPropertyToursWebApiHandler_tours_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  GetToursCountForListingsRequestWebDto,
  UserPropertiesToursCountDto,
  UserPropertyToursDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface ToursParams {
  propertyId: string;
}

export type RentalManagerUserPropertyToursWebApiHandler_getCountForListings_Options = UseQueryOptions<
  Array<UserPropertiesToursCountDto>,
  unknown,
  Array<UserPropertiesToursCountDto>,
  readonly [string, GetToursCountForListingsRequestWebDto]
>;

const RentalManagerUserPropertyToursWebApiHandler_getCountForListings_GetKey = (
  postData: GetToursCountForListingsRequestWebDto,
) => [RentalManagerUserPropertyToursWebApiHandler_getCountForListings_Path, postData] as const;

export const RentalManagerUserPropertyToursWebApiHandler_getCountForListings_queryOptions = (
  postData: GetToursCountForListingsRequestWebDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyToursWebApiHandler_getCountForListings_GetKey(postData),
    queryFn: () => RentalManagerUserPropertyToursWebApiHandler_getCountForListings(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get tours count for listings given a list of listing ids
 */
export const useRentalManagerUserPropertyToursWebApiHandler_getCountForListings = (
  postData: GetToursCountForListingsRequestWebDto,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyToursWebApiHandler_getCountForListings_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyToursWebApiHandler_getCountForListings_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyToursWebApiHandler_getCountForListings.getKey =
  RentalManagerUserPropertyToursWebApiHandler_getCountForListings_GetKey;

export type RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Options = UseQueryOptions<
  Array<string>,
  unknown,
  Array<string>,
  readonly [string]
>;

const RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_GetKey = () =>
  [RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Path] as const;

export const RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_GetKey(),
    queryFn: () => RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get a list of supported external tour providers
 */
export const useRentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders.getKey =
  RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_GetKey;

export type RentalManagerUserPropertyToursWebApiHandler_tours_Options = UseQueryOptions<
  UserPropertyToursDto,
  unknown,
  UserPropertyToursDto,
  readonly [string, ToursParams]
>;

const RentalManagerUserPropertyToursWebApiHandler_tours_GetKey = (getParams: ToursParams) =>
  [RentalManagerUserPropertyToursWebApiHandler_tours_Path, getParams] as const;

export const RentalManagerUserPropertyToursWebApiHandler_tours_queryOptions = (
  getParams: ToursParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyToursWebApiHandler_tours_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyToursWebApiHandler_tours(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get external tours and vr models for a property and its floor plans/units
 */
export const useRentalManagerUserPropertyToursWebApiHandler_tours = (
  getParams: ToursParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyToursWebApiHandler_tours_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyToursWebApiHandler_tours_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyToursWebApiHandler_tours.getKey = RentalManagerUserPropertyToursWebApiHandler_tours_GetKey;
